import React from 'react';
import { Toolbar, ToolbarTitle } from 'material-ui/Toolbar';
import { Card, CardHeader, CardText } from 'material-ui/Card';
import COLORS from '../../../theme/colors';

import './set_up.scss';

export default function SetUp() {
  return (
    <div
      name="set-up"
      id="set-up"
      className="set-up"
    >
      <Toolbar style={{ backgroundColor: COLORS.purple }}>
        <ToolbarTitle
          text="SET-UP"
          style={{ color: COLORS.white }}
        />
      </Toolbar>

      { /* eslint-disable max-len */}
      <div className="content">
        <Card className="card">
          <CardHeader
            title="Create a TeamHub team account"
            titleColor={COLORS.purple}
            actAsExpander
            showExpandableButton
          />
          <CardText expandable>
            Use Add to Slack button from the Home page or the Sign in option here in the right upper corner. You can login with your Google, Slack or Webex account.
          </CardText>
        </Card>

        <Card className="card">
          <CardHeader
            title="Set up your Content Sources"
            titleColor={COLORS.purple}
            actAsExpander
            showExpandableButton
          />
          <CardText expandable>
            Open your TeamHub Dashboard page. To add:
            <ul>
              <li>
                <b>Slack content</b>

                <ul>
                  <li>
                    Use the ADD SLACK button to integrate your Slack team with TeamHub
                  </li>
                  <li>
                    This will open the Slack integration authorization page. To finish the integration press the Authorize button.
                    <br />
                    <i>If you are not currently logged in Slack you need to login to your Slack team first.</i>
                  </li>
                  <li>
                    After you add your Slack team, expand the Manage Settings section to turn on/off the public channels which you want to feature in your TeamHub feed. By default all public channels are turned on.
                  </li>
                </ul>
              </li>
              <b>Note that your TeamHub feed can include any post from the last 24 hours if it has new reactions after the Slack integration.</b>
              <br /><br />
              <li>
                <b>Webex Content</b>
                <ul>
                  <li>
                    Use the ADD WEBEX button to link your Webex account.
                  </li>
                  <li>
                    You will be redirected to a Webex Authorization page. Enter your Webex email and click the Next button.
                    Enter your Webex password and click the Sign In button. This will redirect you to a page with permissions Teamhub wants in order to work with Webex.
                    Click the Accept button to finish the authorization.
                  </li>
                  <li>
                    After you add your Webex account, expand the Manage Settings section to turn on/off the channels you want to feature in your TeamHub feed. By default all public channels are turned on.
                  </li>
                </ul>
              </li>
            </ul>

            <b>Keep in mind that the TeamHub feed will be updated in 5 minutes after you make any changes in the source settings (e.g. turn channels on or off).</b>
          </CardText>
        </Card>

        <Card className="card">
          <CardHeader
            title="Set up your Devices"
            titleColor={COLORS.purple}
            actAsExpander
            showExpandableButton
          />
          <CardText expandable>
            Open your TeamHub Dashboard page. To add:
            <ul>
              <li>
                <b>Chromecast Devices - works only with Google Chrome</b>
                <br />
                You can start broadcasting directly on your TVs with chromecast devices.
                <ul>
                  <li>
                    Just go to Devices in the TeamHub Dashboard page and press the CAST button.
                  </li>
                  <li>
                    Then choose the device you want to use from the list of available devices that appears.
                  </li>
                </ul>
              </li>

              <li>
                <b>Other Devices</b>
                <br />
                You can broadcast TeamHub on any TV or projector screen connected with a PC in screen sharing mode using the Pair option.
                <ul>
                  <li>
                    Open a browser on the shared screen (we recommend Google Chrome) and go to <a href="http://teamhub.tv/tv/" target="_blank" rel="noopener noreferrer">teamhub.tv/tv</a>. You will see a code on the screen.
                    <br />
                    <i>If the TeamHub Dashboard page is opened in the same browser, the TeamHub feed will appear automatically.</i>
                  </li>
                  <li>
                    Then go to Devices in the TeamHub Dashboard page and press the PAIR button.
                  </li>
                  <li>
                    In the dialogue that appears enter the code you see on the device screen and the device name.
                  </li>
                  <li>
                    Press PAIR and your device will appear in the Devices list.
                  </li>
                </ul>
              </li>
            </ul>
          </CardText>
        </Card>
      </div>
      { /* eslint-enable max-len */}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/faq/set_up/set_up.jsx